import { render, staticRenderFns } from "./LoanEligibleForm.vue?vue&type=template&id=56b142c0&"
import script from "./LoanEligibleForm.vue?vue&type=script&lang=js&"
export * from "./LoanEligibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports